import { empty } from 'ramda'

let nil = empty(0) as unknown as undefined

export default nil
